import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_2 = { class: "currency-radio-group" }
const _hoisted_3 = { class: "currency-option" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "currency-code" }
const _hoisted_6 = { class: "rate-value" }
const _hoisted_7 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_8 = {
  key: 0,
  class: "el-form-item__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_form, { "label-position": "top" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "Тип заказа",
        class: _normalizeClass({ 'is-error': _ctx.showErrors && !_ctx.orderType })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: _ctx.orderType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderType) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderTypes, (label, value) => {
                return (_openBlock(), _createBlock(_component_el_radio_button, {
                  key: value,
                  value: value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(label), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.orderType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Выберите тип заказа"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_el_form_item, {
        label: "Валюта",
        class: _normalizeClass({ 'is-error': _ctx.showErrors && !_ctx.currency })
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.currency,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currency) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exchangeRates, (rate) => {
                  return (_openBlock(), _createBlock(_component_el_radio, {
                    key: rate.currency,
                    label: rate.currency,
                    disabled: rate.currency === _ctx.CurrencyEnum.USDT,
                    class: "currency-radio-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                          src: _ctx.getCurrencyFlagUrl(rate.currency),
                          class: "currency-flag"
                        }, null, 8, _hoisted_4),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(rate.currency), 1),
                        _createElementVNode("span", _hoisted_6, "1 " + _toDisplayString(rate.currency) + " = " + _toDisplayString(rate.rate) + " RUB", 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["label", "disabled"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          (_ctx.showErrors && !_ctx.currency)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Выберите валюту"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_el_form_item, {
        label: "Сумма заказа",
        class: _normalizeClass({ 'is-error': _ctx.showErrors && (!_ctx.amount || _ctx.amount <= 0) })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input_number, {
            modelValue: _ctx.amount,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.amount) = $event)),
            min: 0,
            precision: 2,
            controls: false,
            placeholder: "Сумма заказа в валюте",
            class: "amount-input"
          }, null, 8, ["modelValue"]),
          (_ctx.showErrors && (!_ctx.amount || _ctx.amount <= 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Введите сумму заказа"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}